import { useQuery } from "@tanstack/react-query"
import { QRsQuery } from "../../../lib/templates/qr/QRsQuery"

export function useQRsQuery(...args: Parameters<typeof QRsQuery>) {
  return useQuery(QRsQuery(...args))
}
